import Header from "../../component/Header";
import CnSidebar from "./CnSidebar";
import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

// Preset required numbers per model (you can expand this)
const presetCounts = {
  "s10 5g": { dual: 6, single: 4, esim: 3 },
  "s10e": { dual: 4, single: 3, esim: 2 },

  "s20": { dual: 8, single: 5, esim: 4 },
  "s20+": { dual: 10, single: 7, esim: 5 },
  "s20 ultra": { dual: 12, single: 9, esim: 7 },
  "s20 fe": { dual: 7, single: 5, esim: 3 },

  "s21": { dual: 9, single: 6, esim: 5 },
  "s21+": { dual: 11, single: 8, esim: 6 },
  "s21 ultra": { dual: 15, single: 10, esim: 8 },
  "s21 fe": { dual: 6, single: 4, esim: 3 },

  "s22": { dual: 10, single: 7, esim: 6 },
  "s22+": { dual: 12, single: 9, esim: 7 },
  "s22 ultra": { dual: 18, single: 12, esim: 10 },

  "s23": { dual: 11, single: 8, esim: 6 },
  "s23+": { dual: 14, single: 10, esim: 8 },//2wsz
  "s23 ultra": { dual: 20, single: 15, esim: 12 },

  "s24": { dual: 12, single: 9, esim: 7 },
  "s24+": { dual: 15, single: 11, esim: 9 },
  "s24 ultra": { dual: 22, single: 17, esim: 13 },

  "s25": { dual: 14, single: 11, esim: 9 },
  "s25+": { dual: 17, single: 13, esim: 10 },
  "s25 ultra": { dual: 25, single: 19, esim: 15 },
  
  "note 20": { dual: 14, single: 11, esim: 9 },
  "note 20 ultra": { dual: 17, single: 13, esim: 10 },

  "iphone 12": { dual: 8, single: 5, esim: 4 },
  "iphone 12 mini": { dual: 6, single: 4, esim: 3 },
  "iphone 12 pro": { dual: 10, single: 7, esim: 6 },
  "iphone 12 pro max": { dual: 12, single: 9, esim: 7 },

  "iphone 13": { dual: 9, single: 6, esim: 5 },
  "iphone 13 mini": { dual: 6, single: 4, esim: 3 },
  "iphone 13 pro": { dual: 12, single: 9, esim: 7 },
  "iphone 13 pro max": { dual: 15, single: 11, esim: 9 },

  "iphone 14": { dual: 10, single: 7, esim: 6 },
  "iphone 14 plus": { dual: 11, single: 8, esim: 6 },
  "iphone 14 pro": { dual: 14, single: 10, esim: 8 },
  "iphone 14 pro max": { dual: 18, single: 12, esim: 10 },

  "iphone 15": { dual: 11, single: 8, esim: 6 },
  "iphone 15 plus": { dual: 12, single: 9, esim: 7 },
  "iphone 15 pro": { dual: 15, single: 11, esim: 9 },
  "iphone 15 pro max": { dual: 20, single: 15, esim: 12 },

  "iphone 16": { dual: 12, single: 9, esim: 7 },
  "iphone 16 plus": { dual: 13, single: 10, esim: 8 },
  "iphone 16 pro": { dual: 16, single: 12, esim: 10 },
  "iphone 16 pro max": { dual: 22, single: 16, esim: 13 },
  "iphone 16e": { dual: 9, single: 7, esim: 5 },

  "iphone 17": { dual: 13, single: 10, esim: 8 },
  "iphone 17 pro": { dual: 17, single: 13, esim: 10 },
  "iphone 17 pro max": { dual: 23, single: 17, esim: 14 },

  "iphone air": { dual: 7, single: 5, esim: 4 }
};

const keep5GModels = [
  "s10 5g",  // Do NOT ignore 5G for this model
];

function PrepareOrder() {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState(null);
  const [filteredData, setFilteredData] = useState([]);

  const sortByOrderNumber = (data) => {
    return data.sort((a, b) => b.OrderNumber.localeCompare(a.OrderNumber));
  };

function normalizeModel(model) {
  const lower = model.toLowerCase();

  // If in exceptions, return as-is
  if (keep5GModels.includes(lower)) {
    return lower;
  }

  // Remove 5g from other models
  return lower.replace(/\s*5g\b/, "").trim();
}

function buildPresetCounts(models) {
  const counts = {};

  for (const model of models) {
    const key = normalizeModel(model);

    if (!counts[key]) counts[key] = 0;
    counts[key]++;
  }

  return counts;
}

 const fetchData = async () => {
     try {
       setLoading(true);
       const response = await axios.get(`${apiUrl}/sortedItems`);
       const fetchedData = response.data.map((item) => ({
         brand: item.Brand.trim().toLowerCase(),
         model: buildPresetCounts(item.Model.trim().toLowerCase()),
         storage: item.Storage.trim(),
         ram: item.Ram.trim(),
         sim: item.Sim.trim().toLowerCase(),
       }));
 
       const grouped = new Map();
 
       fetchedData.forEach((item) => {
         const key = `${item.model}-${item.storage}-${item.sim}`;
         const existing = grouped.get(key);
 
         if (!existing) {
           grouped.set(key, { ...item, count: 1 });
         } else {
           // Increment count
           existing.count += 1;
 
           // Keep item with the higher price
           if (item.price > existing.price) {
             existing.price = item.price;
           }
 
           grouped.set(key, existing);
         }
       });
 
    //    const filteredData = Array.from(grouped.values()).sort((a, b) =>
    //      a.model.localeCompare(b.model)
    //    );
 const filteredData = Array.from(grouped.values())
  .map(item => {
    const preset = presetCounts[item.model]?.[item.sim] || 0;

    return {
  ...item,
  preset,
  orderNeed: preset - item.count
};
  })
  .sort((a, b) => a.model.localeCompare(b.model));
       setFilteredData(filteredData);
       setLoading(false);
     } catch (error) {
       setLoading(false);
       setErrors(error.response?.data?.message || "An error occurred");
     }
   };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Header />
      <CnSidebar />
      <div className="items-center flex flex-col justify-center mt-5 overflow-auto">
        <div className=" border-1 border-slate-200 mt-20 w-3/4 mb-20 px-5 rounded-md overflow-auto justify-center align-middle">
          <h1 className="font-bold text-2xl my-3">Available Phones</h1>
          <table className="border-collapse table-auto w-full mb-10 overflow-x-scroll">
            <thead>
              <tr>
                <th className="border-b-1 pb-3 border-slate-600 text-left bg-gray-300">
                  Brand
                </th>
                <th className="border-b-1 pb-3 border-slate-600 text-left bg-gray-200">
                  Model
                </th>
                <th className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-300">
                  Storage
                </th>
                <th className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200">
                  Ram
                </th>
                <th className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-300">
                  Sim
                </th>
                <th className="border-b-1 pb-3 border-slate-600 text-left bg-gray-300">Preset</th>
<th className="border-b-1 pb-3 border-slate-600 text-left bg-gray-300">Order Need</th>

              </tr>
            </thead>
            <tbody>
              {filteredData.map((item, index) => {
                return (
                  <tr key={index}>
                    <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200">
                      {item.brand}
                    </td>
                    <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                      {item.model}
                    </td>
                    <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200">
                      {item.storage}
                    </td>
                    <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-100">
                      {item.ram}
                    </td>
                    <td className="border-b-1 pb-3 border-slate-600 text-left m-0 bg-gray-200">
                      {item.sim}
                    </td>
                    <td className="border-b-1 pb-3 border-slate-600 text-left bg-gray-200">
  {item.preset}
</td>
<td className="border-b-1 pb-3 border-slate-600 text-left bg-gray-200">
  {item.orderNeed}
</td>

                  </tr>
                );
              })}
            </tbody>
          </table>
          <div className="flex flex-row">
            <h1 className="text-2xl font-bold mr-2">Total Remaining: </h1>
            <p className="text-2xl underline"> {filteredData.length}</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default PrepareOrder;
